import { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { NavMarker } from 'react-rhumb';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'Nabi... Remove this comment to see the full error message
import HubSpotOnlyAppCookieLogin from 'Nabisco/app/HubSpotOnlyAppCookieLogin';
import { stringify } from 'hub-http/helpers/params';
import GoogleLoginConfirmation from '../google/GoogleLoginConfirmation';
import SsoRequiredAuthStatuses from '../../constants/SsoRequiredAuthStatuses';
import GoogleLoginDao from '../../data/GoogleLoginDao';
import LoginDao from '../../data/LoginDao';
import googleLoginNonce from '../../lib/googleLoginNonce';
import LoginFailureHandlerFactory from '../../lib/LoginFailureHandlerFactory';
import { isLocalhostAuthUrl } from '../../utils/urls';
import TwoFactorAuthStatuses from '../../constants/TwoFactorAuthStatuses';
import ConfirmToLoginAuthStatuses from '../../constants/ConfirmToLoginAuthStatuses';
import { setTwoFactorMethod, setCredentials } from '../../actions';
import { jsx as _jsx } from "react/jsx-runtime";
const loginDao = new LoginDao();
const appCookieLogin = new HubSpotOnlyAppCookieLogin({
  loginRequest: loginDao.googleLogin.bind(loginDao),
  passThroughFallback: true
});
const googleLoginDao = new GoogleLoginDao();
class GoogleLoginConfirmationLanding extends Component {
  constructor(...args) {
    super(...args);
    this.state = {
      loginPortalId: undefined,
      loginRedirectUrl: ''
    };
    this.onFinish = responses => {
      const response = responses[0];
      switch (response.status) {
        case TwoFactorAuthStatuses.TWO_FACTOR_REQUIRED:
          return this.handleTwoFactorRequired(response);
        case ConfirmToLoginAuthStatuses.SUSPICIOUS_USER_MUST_CONFIRM:
          return this.handleSuspiciousUserMustConfirm(response);
        case SsoRequiredAuthStatuses.SSO_LOGIN_REQUIRED:
          return this.handleSsoRequired(response);
        default:
          return appCookieLogin.redirectOnLoginSuccess(responses);
      }
    };
    this.handleTwoFactorRequired = response => {
      const {
        loginPortalId,
        loginRedirectUrl
      } = this.state;
      const {
        email,
        token,
        primary,
        secondary,
        backupCodesEnabled
      } = response;
      this.props.setTwoFactorMethod(token, primary, secondary, backupCodesEnabled);
      this.props.setCredentials({
        email
      });
      const nextPath = `/two-factor?${stringify({
        loginPortalId,
        loginRedirectUrl
      })}`;
      this.props.history.push(nextPath);
    };
    this.handleSuspiciousUserMustConfirm = response => {
      const {
        loginPortalId,
        loginRedirectUrl
      } = this.state;
      const {
        token,
        email
      } = response;
      this.props.setTwoFactorMethod(token, null, null, false);
      this.props.setCredentials({
        email
      });
      const nextPath = `/confirm-to-login?${stringify({
        loginRedirectUrl,
        loginPortalId
      })}`;
      this.props.history.push(nextPath);
    };
    this.handleSsoRequired = response => {
      const {
        loginRedirectUrl,
        loginPortalId
      } = this.state;
      const {
        hubId
      } = response;
      const nextPath = `/sso?${stringify({
        loginPortalId: loginPortalId || hubId,
        required: true,
        loginRedirectUrl
      })}`;
      return this.props.history.push(nextPath);
    };
    this.onGoogleLoginClick = (fragmentState, triggerFailure) => {
      const {
        loginPortalId,
        loginRedirectUrl,
        rememberLogin
      } = fragmentState;
      const credentials = {
        loginPortalId,
        loginRedirectUrl,
        rememberLogin
      };
      googleLoginDao.initialize(credentials).then(googleLoginNonce.storeAndRedirect).catch(LoginFailureHandlerFactory.createRavenReporter('Google initialization failed', triggerFailure, this.props.history.push));
    };
    this.loginSubmit = (idToken, fragmentState, triggerFailure) => {
      const {
        client,
        loginPortalId,
        loginRedirectUrl,
        googleLoginRedirectUrl,
        rememberLogin
      } = fragmentState;
      this.setState({
        loginPortalId,
        loginRedirectUrl: googleLoginRedirectUrl || loginRedirectUrl
      });
      const credentials = {
        idToken,
        client,
        loginPortalId,
        loginRedirectUrl: googleLoginRedirectUrl || loginRedirectUrl,
        nonce: googleLoginNonce.get(),
        rememberLogin
      };
      const extraSearchObject = {
        loginPortalId,
        loginRedirectUrl: googleLoginRedirectUrl || loginRedirectUrl
      };
      if (isLocalhostAuthUrl(loginRedirectUrl)) {
        window.location.href = `${loginRedirectUrl}?google=${btoa(JSON.stringify(credentials))}`;
      } else {
        appCookieLogin.login(credentials).then(this.onFinish).catch(LoginFailureHandlerFactory.createRavenReporter('Google login failed', triggerFailure, this.props.history.push, extraSearchObject));
      }
    };
  }
  componentDidMount() {
    appCookieLogin.loginPrep();
  }
  render() {
    return /*#__PURE__*/_jsx(NavMarker, {
      name: "GOOGLE_LOGIN_REDIRECT_LOAD",
      children: /*#__PURE__*/_jsx(GoogleLoginConfirmation, {
        onGoogleLoginClick: this.onGoogleLoginClick,
        onLoginSubmit: this.loginSubmit
      })
    });
  }
}
GoogleLoginConfirmationLanding.propTypes = {
  history: PropTypes.object.isRequired,
  setTwoFactorMethod: PropTypes.func.isRequired,
  setCredentials: PropTypes.func.isRequired
};
export default connect(null, {
  setTwoFactorMethod,
  setCredentials
})(GoogleLoginConfirmationLanding);